

















































import { Component, Vue } from 'vue-property-decorator';
import Canvas from './components/Canvas.vue';
import SideMenu from './components/SideMenu.vue';
import Footer from './components/Footer.vue';
import Header from './components/Header.vue';
import { Data } from './components/Meta';

@Component({
  components: {
    Canvas,
    SideMenu,
    Footer,
    Header
  }
})
export default class App extends Vue {
  data = new Data();
  changeData(data: Data) {
    this.data = data;
  }

  fab = false;
  onScroll(e: any) {
    if (typeof window === 'undefined') return;
    const top = window.pageYOffset ||   e.target.scrollTop || 0;
    this.fab = top > 100;
  }
}
